import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!

  return (_openBlock(), _createBlock(_component_ContentAdaptLayout, { style: {"padding":"10px 20px 20px","box-sizing":"border-box"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        width: "100%",
        height: "100%",
        data: _ctx.data.transfer_device_list,
        "empty-text": _ctx.$t('common.noData')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "computer_name",
            label: _ctx.$t('listColumns.computerName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "user_mark",
            label: _ctx.$t('listColumns.userMark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "old_group_name",
            label: _ctx.$t('noticeManage.oldGroupName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "new_group_name",
            label: _ctx.$t('noticeManage.newGroupName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.new_group_name), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "empty-text"])
    ]),
    _: 1
  }))
}